import React, {Component} from 'react'
import {Button, Form, Row, Col, Table, Spin, InputNumber, Switch} from 'antd'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'

@inject('fatigueConfigStore')
@observer
class fatigueConfig extends Component {
  formRef = React.createRef()

  state = {}

  handleSwitchChange = (record, field, value) => {
    const {fatigueConfigStore} = this.props
    fatigueConfigStore.modifyGroupMode(record, field, value)
  }

  columns = [
    {
      title: '项目组',
      dataIndex: 'groupName',
      align: 'center',
    },
    {
      title: '特权模式',
      dataIndex: 'isPrivilegedMode',
      align: 'center',
      render: (checked, record) => (
        <Switch checked={checked} onChange={val => this.handleSwitchChange(record, 'isPrivilegedMode', val)}/>
      ),
    },
    {
      title: '管理员模式',
      dataIndex: 'isAdminMode',
      align: 'center',
      render: (checked, record) => (
        <Switch checked={checked} onChange={val => this.handleSwitchChange(record, 'isAdminMode', val)}/>
      ),
    },
  ]

  handleSearch = () => {
    const {fatigueConfigStore} = this.props

    this.formRef.current.validateFields().then(() => {
      fatigueConfigStore.getFatigueValue().then(res => {
        if (res.code === 0) {
          this.formRef.current.setFieldsValue(res.data.fatigueValueRule || {})
        }
      })
    }).catch()
  }

  handleSave = () => {
    const {fatigueConfigStore} = this.props

    this.formRef.current.validateFields().then(fieldsValue => {
      const params = {
        ...fieldsValue,
        id: fatigueConfigStore.fatigueValue.id,
      }
      fatigueConfigStore.modifyFatigueValue(params)
    }).catch()
  }

  handleReset = () => {
    this.formRef.current.resetFields()
  }

  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  componentDidMount() {
    this.handleSearch()
  }

  render() {
    const {t, fatigueConfigStore} = this.props
    const {isFetching, fatigueValue, groupInfoList} = fatigueConfigStore

    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <Form ref={this.formRef} size="middle" className="searchForm" initialValues={fatigueValue}>
            <div className="searchFormTitle">
              全局配置
            </div>
            <Row gutter={[10, 0]}>
              <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
                <Form.Item name="marketingSmsNumber" label="营销短信">
                  <InputNumber placeholder={t(`general.pleaseEnter`)} style={{width: '100%'}} size="large"/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
                <Form.Item name="emailNumber" label="邮件">
                  <InputNumber placeholder={t(`general.pleaseEnter`)} style={{width: '100%'}} size="large"/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
                <Form.Item name="aiCallNumber" label="智能外呼">
                  <InputNumber placeholder={t(`general.pleaseEnter`)} style={{width: '100%'}} size="large"/>
                </Form.Item>
              </Col>
              <Col  xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
                <Form.Item name="weekFatigueValueRecoverNumber" label="每周疲劳值恢复">
                  <InputNumber placeholder={t(`general.pleaseEnter`)} style={{width: '100%'}} size="large"/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
                <Form.Item name="totalFatigueValueLimit" label="总疲劳值上限">
                  <InputNumber placeholder={t(`general.pleaseEnter`)} style={{width: '100%'}} size="large"/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
                <Form.Item name="weekFatigueValueLimit" label="每周疲劳值上限">
                  <InputNumber placeholder={t(`general.pleaseEnter`)} style={{width: '100%'}} size="large"/>
                </Form.Item>
              </Col>
              <Col flex='auto' style={{textAlign: 'right', marginBottom: 10}}>
                <Button onClick={this.handleReset} type='danger'>还原</Button>
                <Button onClick={this.handleSave} type="primary">保存</Button>
              </Col>
            </Row>
          </Form>

          <div style={{background: 'white', marginTop: '20px', padding: '15px 0'}}>
            <div style={{display: 'flex', alignItems: 'center', padding: '0 15px'}}>
              <h3 style={{marginRight: 20, marginBottom: 0}}>项目组特权</h3>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <span className="f_red">*每周一凌晨恢复配置数量疲劳值。</span> 疲劳值区间：
                <span style={{display: 'inline-block', width: 10, height: 10, background: '#52c41a'}}></span>&nbsp;= 14
                无疲劳 &nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{display: 'inline-block', width: 10, height: 10, background: '#fadb14'}}></span>&nbsp;&gt; 5 ~ &lt; 14
                轻度疲劳 &nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{display: 'inline-block', width: 10, height: 10, background: '#fa8c16'}}></span>&nbsp;&gt; 0 ~ &lt;= 5
                中度疲劳 &nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{display: 'inline-block', width: 10, height: 10, background: '#f5222d'}}></span>&nbsp;&gt; -4 ~ &lt;= 0
                重度疲劳 &nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{display: 'inline-block', width: 10, height: 10, background: '#722ed1'}}></span>&nbsp;&lt;= -4
                严重疲劳 &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <Table
              style={{marginTop: 0}}
              className="searchResult"
              rowClassName={this.getRowClassName}
              bordered
              dataSource={groupInfoList}
              columns={this.columns}
              pagination={false}
              rowKey="id"
            />
            <div className="f_red" style={{marginTop: '10px', padding: '0 15px'}}>*特权模式可以在严重疲劳区间进行营销任务，管理员模式不受疲劳值标签限制。</div>
          </div>
        </div>
      </Spin>
    )
  }
}

export default withTranslation()(fatigueConfig)
